import React from "react";
import { Link } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { GraduationCap, Church, Music, Cpu, Truck, HeartHandshake, ArrowRight } from "lucide-react";

const values = [
  { icon: GraduationCap, title: "For every student", text: "Approved textbooks & study aids for primary, secondary and university." },
  { icon: Church, title: "For the faithful", text: "Bibles, devotionals and inspirational christian literature." },
  { icon: Music, title: "Beyond books", text: "Musical instruments and computer accessories under one roof." },
  { icon: HeartHandshake, title: "Trusted locally", text: "A friendly, family-run shop serving Abeokuta with care." },
];

export default function About() {
  const { settings } = useStore();
  return (
    <div data-testid="about-page">
      <section className="bg-brand-blue border-b-2 border-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 md:py-24 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tighter text-white leading-none">
              About <span className="text-brand-gold">BooksNmore</span>
            </h1>
            <p className="mt-6 text-white/75 text-lg leading-relaxed">
              {settings?.about ||
                "BooksNmore is a trusted bookshop in Abeokuta, serving students, families and churches with quality educational books, stationery, bibles, christian literature, musical instruments and computer accessories."}
            </p>
          </div>
          <div className="border-2 border-black rounded-lg overflow-hidden shadow-brutal-lg -rotate-1">
            <img
              src="https://images.unsplash.com/photo-1780386507050-d55e28cab1a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjB2aWJyYW50JTIwYm9va3N0b3JlJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg2MzgxNDQzfDA&ixlib=rb-4.1.0&q=85&w=900"
              alt="Inside BooksNmore"
              className="w-full h-[360px] object-cover"
            />
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 md:py-24">
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-brand-blue mb-10">What we're about</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {values.map((v, i) => (
            <div key={i} className="bg-white border-2 border-black rounded-lg p-6 shadow-brutal hover:-translate-y-1 hover:shadow-brutal-lg transition-all duration-200">
              <span className="w-11 h-11 flex items-center justify-center bg-brand-gold border-2 border-black rounded-md mb-4">
                <v.icon className="w-5 h-5 text-brand-blue" strokeWidth={2.5} />
              </span>
              <h3 className="font-display font-bold text-lg text-brand-black">{v.title}</h3>
              <p className="mt-2 text-sm text-brand-black/60 leading-relaxed">{v.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-brand-cream border-2 border-black rounded-lg shadow-brutal p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <Truck className="w-10 h-10 text-brand-blue" />
            <div>
              <p className="font-display font-bold text-xl text-brand-blue">Web store coming soon</p>
              <p className="text-brand-black/60">Order online with secure Paystack payments. For now, order by phone or WhatsApp.</p>
            </div>
          </div>
          <Link to="/contact" className="inline-flex items-center gap-2 bg-brand-blue text-white font-semibold px-6 py-3 border-2 border-black rounded-md shadow-brutal hover:-translate-y-0.5 transition-all shrink-0" data-testid="about-contact-btn">
            Get in touch <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
